import { LOGIN_KEY } from '../action-type'
import cookie from "../../utils/store/cookie";

let defaultState = {
	footer: true,
	home: true,
	homeActive: false,
	token: cookie.get('login_status') || null,
	backgroundColor: "#fff",
	userInfo: null,
	isLoading:false,
	cate_qty:0,
	item_qty:0,
	repair_qty:0,
	process_qty:0,
	req_qty:0
}

export default (state = defaultState, action = {}) => {

	switch (action.type) {
	  case 'change_cart_qty':
			return {
				...state,
				cate_qty: action.cate_qty,
				item_qty:action.item_qty
			}
		case 'change_repair_qty':
			return {
				...state,
				repair_qty:action.repair_qty,
				process_qty: action.process_qty,
				req_qty:action.req_qty
			}
		case 'demo1':
			return {
				...state,
				userInfo: action.data
			}
		case 'LOGIN':
			cookie.set(LOGIN_KEY, action.token, action.expires_time)
			return {
				...state,
				token: action.token
			}
		case 'LOGOUT':
			cookie.remove(LOGIN_KEY)
			return {
				...state,
				token: undefined
			}
		case 'LOADING_START':
			return {
				...state,
				isLoading: true
			}
		case 'LOADING_END':
			return {
				...state,
				isLoading: false
			}
		default:
			return state
	}
}
